import Vue from 'vue';
import store from '@/store.js';
import snackbar from './snackbar';
import i18n from '@/i18n';

function permissionAllow(c, a) {
    if (store.state.allow) {
        let controller = store.state.allow[c];
        if (controller) {
            if (!controller.find((action) => a == action))
                return false;
        } else return false;

        return true;
    }
    return false;
}

function accountExpired() {
    return new Date() > new Date(Date.parse(store.state.accountInfo.time_expired + 86400000));
}
Vue.filter('accountExpired', accountExpired);

async function checkAccountExpired() {
    return new Promise((resolve) => {
        if (!accountExpired()) {
            resolve();
        } else {
            snackbar.error(i18n.t("App.accountExpired"));
        }
    });
}

function checkPushPlatformEnabled(platform_code) {//工具方法，检查三方平台是否启用
    return store.state.settings &&
        ((store.state.settings.push_platform && store.state.settings.push_platform == platform_code)
            || (store.state.settings.push_platform_setting && store.state.settings.push_platform_setting[platform_code]));
}

const pushPlatforms = {
    kingdee: 1018,//金蝶
    chanjet: 1019,//畅捷通
}


export default {
    permissionAllow,
    accountExpired,
    checkAccountExpired,
    checkPushPlatformEnabled,
    pushPlatforms,
}